import { ProgramContentType } from "data/BlockComponent";
import TextareaCell from "./TextareaCell";
import { Stack } from "@mui/joy";
import { useRecoilValue } from "recoil";
import { patientAtom } from "recoil/patientAtom";

export default function AiCommentCell({
  taskKey,
  thoughtRecordKey,
  initialValue,
  aiCommentValue,
  isCoach,
  blockIndex,
  setData,
  lineIndex,
  cellIndex,
  editorKey,
  aiCommentKey,
}: {
  taskKey: string;
  thoughtRecordKey?: string;
  initialValue?: string;
  aiCommentValue?: string;
  isCoach?: boolean;
  blockIndex: number;
  setData: React.Dispatch<
    React.SetStateAction<ProgramContentType[] | undefined>
  >;
  lineIndex: number;
  cellIndex: number;
  editorKey?: string;
  aiCommentKey: string;
}) {
  const patientState = useRecoilValue(patientAtom);

  return (
    <Stack spacing={0.5} alignItems="end">
      <TextareaCell
        initialHtmlString={`<p>${initialValue}</p>`}
        initialValue={initialValue}
        isCoachField
        isCoach={isCoach}
        setData={setData}
        lineIndex={lineIndex}
        cellIndex={cellIndex}
        blockIndex={blockIndex}
        editorKey={editorKey}
      />
    </Stack>
  );
}